import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
  fr: { translation: fr },
  pt: { translation: pt }
};

// Language display names
export const languages = {
  es: { name: 'Español', flag: '🇪🇸', code: 'ES' },
  en: { name: 'English', flag: '🇬🇧', code: 'EN' },
  fr: { name: 'Français', flag: '🇫🇷', code: 'FR' },
  pt: { name: 'Português', flag: '🇵🇹', code: 'PT' }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
